import React, { useEffect } from 'react';
import type { RenderModalWrapperProps } from '@atlassian/jira-command-palette';
import { useQuickSearchAnalyticsAttributes } from '../../../../controllers/use-quick-search-analytics';
import { QuickSearchWrapper } from '../../../../controllers/use-quick-search-analytics/wrapper';
import { QuickSearchFireScreenAnalytics } from './fire-screen-analytics';

export const QuickSearchChildWrapper = ({ children }: RenderModalWrapperProps) => {
	const [attributes, { reset }] = useQuickSearchAnalyticsAttributes();

	useEffect(() => {
		reset();
		return () => {
			reset();
		};
	}, [reset]);

	const shouldFireScreenAnalytics = attributes.queryVersion >= 0;
	return (
		<QuickSearchWrapper>
			{shouldFireScreenAnalytics && <QuickSearchFireScreenAnalytics />}
			{children}
		</QuickSearchWrapper>
	);
};
